// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-00efc345]{background:#fff;border:1px solid #edeef0;box-sizing:border-box;border-radius:10px;padding:60px 90px;justify-content:center}.card[data-v-00efc345],.content[data-v-00efc345]{display:flex;align-items:center}.content[data-v-00efc345]{width:100%;flex-direction:column}", ""]);
// Exports
module.exports = exports;
